import axios from 'axios'
import { EnumRegisterStatus } from 'interfaces'
import { TenantIdentifierSubdomainContract } from 'models'
import { RegisterCompanyContract } from 'models/RegisterCompanyContract'
import qs from 'query-string'
import getEnv from 'utilities/getEnv'

const CLOUD_API = getEnv('REACT_APP_CLOUD_API')

const vanillaHttpClient = axios.create({
    timeout: 30000,
    baseURL: CLOUD_API,
    headers: {
        'Content-Type': 'application/json',
    },
    paramsSerializer: (params) => {
        return qs.stringify(params)
    },
})

const GLOBAL_PREFIX = '/global'

const globalService = {
    register: (payload: RegisterCompanyContract) =>
        vanillaHttpClient.post(`${GLOBAL_PREFIX}/company/Register`, payload),
    checkUsername: (username: string) =>
        vanillaHttpClient.get<boolean>(
            `${GLOBAL_PREFIX}/company/check-username`,
            {
                params: {
                    username,
                },
            },
        ),
    checkSubdomain: (subdomain: string) =>
        vanillaHttpClient.get<boolean>(
            `${GLOBAL_PREFIX}/company/check-subdomain`,
            {
                params: {
                    subdomain,
                },
            },
        ),
    checkRegisterStatus: (subdomain: string) =>
        vanillaHttpClient.get<EnumRegisterStatus>(
            `${GLOBAL_PREFIX}/company/register-status`,
            {
                params: {
                    subdomain,
                },
            },
        ),
    getSubdomainInfo: (subdomain: string) =>
        vanillaHttpClient.get<TenantIdentifierSubdomainContract>(
            `${GLOBAL_PREFIX}/company/subdomain-info`,
            { params: { subdomain } },
        ),
}

export default globalService
